// extracted by mini-css-extract-plugin
export default {"picture_management":"MemberKYC_picture_management__zR4kJ","verify_info":"MemberKYC_verify_info__70td+","picture_title":"MemberKYC_picture_title__Yy9Ek"};